export default "__VITE_ASSET__cFRTiXN8__"